import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-ops-alarm-topbar-xsmall',
    templateUrl: './ops-alarm-topbar-xsmall.component.html',
    styleUrls: ['./ops-alarm-topbar-xsmall.component.css'],
    standalone: false
})
export class OpsAlarmTopbarXsmallComponent {
    @Input() title: string;
    @Output() onBackEmit = new EventEmitter();

    onBack() {
        this.onBackEmit.emit();
    }
}
